// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kEJVC","copy":"styles_copy__onPWf","copyNoMargin":"styles_copyNoMargin__y4Vlh","confirm":"styles_confirm__KQ0pP"};